var render = function render(){var _vm=this,_c=_vm._self._c;return _c('kimsa-confirm',{ref:"cancelModal",attrs:{"title":_vm.$t('payment.cancel_subscription'),"content":_vm.bodyMessage,"loading":_vm.loadingSubscribeCancel,"persistent":false,"close-on-confirm":false,"alert-mode":true},on:{"confirm":_vm.confirmSubscriptionCancel}})
}
var staticRenderFns = []

export { render, staticRenderFns }